export default ({ dropdown, typography }) => ({
  dark: {},
  root: {
    '&$dark': {
      color: dropdown.dark.breadcrumbColor,
    },
    border: 0,
    color: dropdown.breadcrumbColor,
    display: 'block',
    fontSize: typography.fontSize,
    fontFamily: dropdown.breadcrumbFontFamily,
    lineHeight: '16px',
    padding: [4, 20, 4, 12],
    textAlign: 'left',
    width: '100%',
  },
  breadcrumb: {
    '&$dark': {
      '&:focus': {
        outlineColor: dropdown.dark.darkFocusColor,
      },
      color: dropdown.dark.breadcrumbColor,
    },
    background: 'transparent',
    border: 0,
    color: dropdown.breadcrumbColor,
    padding: 0,
    fontSize: typography.fontSize,
    fontFamily: dropdown.breadcrumbFontFamily,
    textAlign: 'left',
    lineHeight: '16px',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
    '&:focus': {
      outlineColor: dropdown.focusColor,
    },
  },
  caret: {
    margin: [0, 6],
    position: 'relative',
    top: 2,
    '& svg': {
      fill: dropdown.border,
    },
  },
});
